export default "__VITE_ASSET__BbIlr3Wq__"